export default __webpack_public_path__ + "static/media/logo_black.4a71bea4.svg";